module.exports = __webpack_public_path__ + "674f50d287a8c48dc19ba404d20fe713.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/vendor/font-awesome-4.7.0/fonts/fontawesome-webfont.eot
// module id = 698
// module chunks = 49